import { Reveal } from "./Reveal";
import { useContent } from "../lib/content";

export const Brands = () => {
  const { brands } = useContent();
  if (!brands.length) return null;
  return (
    <section className="py-16 bg-[#fafaf7] border-y border-black/5 overflow-hidden" data-testid="brands-section">
      <Reveal>
        <p className="text-center uppercase tracking-[0.28em] text-xs font-bold text-[#91008d]/70 mb-10 px-6">
          Some of the amazing businesses, we have worked with!
        </p>
      </Reveal>
      <div className="overflow-hidden">
        <div className="marquee-track" style={{ animationDuration: "28s" }}>
          {[0, 1].map((dup) => (
            <div key={dup} className="flex items-center shrink-0">
              {brands.map((b) => (
                <div
                  key={`${dup}-${b.id}`}
                  className="px-10 flex items-center justify-center"
                  data-testid={dup === 0 ? `brand-item-${b.name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}` : undefined}
                >
                  {b.logo_src ? (
                    <img
                      src={b.logo_src}
                      alt={b.name}
                      className="h-14 w-auto object-contain grayscale hover:grayscale-0 opacity-70 hover:opacity-100 transition-all duration-500"
                    />
                  ) : (
                    <span className="font-serif italic text-2xl text-[#3c003a]/55 whitespace-nowrap hover:text-[#c9006f] transition-colors duration-300">
                      {b.name}
                    </span>
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
